export const LANGUAGELIST_SEARCH = 'LANGUAGELIST_SEARCH';
export const LANGUAGELIST_PAGE = 'LANGUAGELIST_PAGE';
